import { AlertsManagementListOrderKey } from '../domain/alertsManagementFilterModel';
import { useListOrder } from '../../filter/hooks/useListOrder';

export const useAlertsManagementListOrder = () => {
  return useListOrder(AlertsManagementListOrderKey, 'alertsManagementOrderBy', true);
};
